import { useMutation } from '@apollo/client';
import DELETE_FLASHCARD from 'graphql/mutations/flashcards/DeleteFlashcard.graphql';
import { getIDFromPK } from 'utilities';

export default function useDeleteFlashcardMutation() {
  return useMutation(DELETE_FLASHCARD, {
    update(cache, { data: { deleteFlashcard } }) {
      if (!deleteFlashcard) {
        console.warn(
          'Failed to delete a Flashcard record through GraphQL. It may not exist in the database.',
        );

        return;
      }

      cache.modify({
        fields: {
          flashcardsByEpub(existingFlashcards, { readField }) {
            const id = getIDFromPK(
              deleteFlashcard.flashcardId,
              'FlashcardNode',
            );
            const cacheId = `FlashcardNode:${id}`;
            const updatedEdges = existingFlashcards.edges.filter(
              (existingFlashcard) => cacheId !== existingFlashcard.node.__ref,
            );
            return {
              __typename: existingFlashcards.__typeName,
              edges: updatedEdges,
            };
          },
        },
      });
    },
  });
}
